import { persist } from '@/assets/js/util.js'

const data = {
    email: ''
}

const context = persist('user', data)

export default context
